'use client';

import { Tooltip as MantineTooltip } from '@mantine/core';

export interface ITooltip {
  withArrow?: boolean;
  arrowSize?: number;
  children: React.ReactNode;
  label?: string;
  dataTestId?: string;
  disabled?: boolean;
}

export const Tooltip = ({ children, label, withArrow = false, arrowSize = 12, dataTestId, disabled }: ITooltip) => (
  <MantineTooltip
    withArrow={withArrow}
    arrowSize={arrowSize}
    label={label}
    events={{ hover: true, focus: true, touch: true }}
    disabled={disabled}
  >
    <div data-testid={dataTestId}>{children}</div>
  </MantineTooltip>
);

Tooltip.displayName = 'Tooltip';
